export const Layout = {
  width: {
    wd: 1920,
    xl: 1100,
    lg: 1050,
    md: 750,
    sm: 550,
  },
};
